import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { GenericApiService } from '@pm-ui/core-services';
import { Observable } from 'rxjs';
import { StandardLinesEndpoints } from '../../config/standardLines/standard-lines-end-points';

@Injectable({
  providedIn: 'root'
})
export class StandardLinesService {

  constructor(private genericApiService: GenericApiService,private _http: HttpClient) { }

  getCategoryDropDown<T>(siteId:number,categoryId:number): Observable<any>{
    return this.genericApiService.get<T>(`${StandardLinesEndpoints.GetCategoryList}/${siteId}/${categoryId}`);
   }
  // getCategoryDropDown<T>(siteId:number): Observable<any>{    
  //   return this.genericApiService.post(StandardLinesEndpoints.GetCategoryList, siteId);
  // }
  addUpdateStandardLine<T>(reqModel:any): Observable<unknown>{        
    return this.genericApiService.post(StandardLinesEndpoints.AddUpdateStandardLine, reqModel);
  }
  deleteStandardLines<T>(userId: number,SiteId:number): Observable<HttpResponse<T>> {
    return this.genericApiService.delete(`${StandardLinesEndpoints.DeleteStandardLines}/${userId}/${SiteId}`);
  }
  getAllStandardLine<T>(reqModel:any): Observable<any>{    
    return this.genericApiService.post(StandardLinesEndpoints.GetStandardLine, reqModel);
  }
  getStandardLineBySiteCategory<T>(reqModel:any): Observable<any>{    
    return this.genericApiService.post(StandardLinesEndpoints.GetStandardLineBySiteCategory, reqModel);
  }

  GetStandardLineDataReArrange<T>(reqModel:any): Observable<unknown>{ 
    return this.genericApiService.post(StandardLinesEndpoints.GetStandardLineDataReArrange, reqModel);
  }
  checkStandardLineCategory<T>(userId: number,SiteId:number): Observable<HttpResponse<T>> {
    return this.genericApiService.delete(`${StandardLinesEndpoints.CheckActiveStandardLineCategory}/${userId}/${SiteId}`);
  }


  addUpdatePrestartTemplates<T>(reqModel:any): Observable<unknown>{        
    return this.genericApiService.post(StandardLinesEndpoints.AddUpdatePrestartTemplates, reqModel);
  }
  getAllPrestartTemplates<T>(reqModel:any): Observable<any>{    
    return this.genericApiService.post(StandardLinesEndpoints.GetPrestartTemplates, reqModel);
  }

  deletePrestartTemplates<T>(userId: number): Observable<HttpResponse<T>> {
    return this.genericApiService.delete(`${StandardLinesEndpoints.DeletePrestartTemplates}/${userId}`);
  }


  addUpdateWorkTemplates<T>(reqModel:any): Observable<unknown>{        
    return this.genericApiService.post(StandardLinesEndpoints.AddUpdateWorkTemplates, reqModel);
  }
  getAllWorkTemplates<T>(reqModel:any): Observable<any>{    
    return this.genericApiService.post(StandardLinesEndpoints.GetWorkTemplates, reqModel);
  }
  deleteWorkTemplates<T>(userId: number): Observable<HttpResponse<T>> {
    return this.genericApiService.delete(`${StandardLinesEndpoints.DeleteWorkTemplates}/${userId}`);
  }

  addUpdateCompletionTemplates<T>(reqModel:any): Observable<unknown>{        
    return this.genericApiService.post(StandardLinesEndpoints.AddUpdateCompletionTemplates, reqModel);
  }
  getAllCompletionTemplates<T>(reqModel:any): Observable<any>{    
    return this.genericApiService.post(StandardLinesEndpoints.GetCompletionTemplates, reqModel);
  }
  deleteCompletionTemplates<T>(userId: number): Observable<HttpResponse<T>> {
    return this.genericApiService.delete(`${StandardLinesEndpoints.DeleteCompletionTemplates}/${userId}`);
  }

}
